import React from 'react';
import PropTypes from 'prop-types';
import { Hidden } from 'react-grid-system';
import { getLocalizedText as text } from '@vp-dst/localization-util';

import ColorUtil from 'utils/ColorUtil';
import BundleUtil from 'utils/BundleUtil';
import { colors, defaultTextStyle } from 'settings/theme';

import withScreenClass, { withScreenClassPropTypes } from 'components/highOrder/withScreenClass';
import Button from 'components/vistaprintUILibrary/Button';
import Price from 'components/vistaprintUILibrary/Price';
import TextLink from 'components/vistaprintUILibrary/TextLink';
import Typography from 'components/vistaprintUILibrary/Typography';
import ServiceHighlight from 'components/ServiceHighlight';

function Service(props) {
  const {
    iconSrc,
    title,
    caption,
    priceHTML,
    highlights,
    iconOnClick,
    buttonOnClick,
    buttonLinkHref,
    linkText,
    linkHref,
    screenClass,
    buttonTextOverride,
    hideCheckmarks,
    showNewCallout,
    highlightsTextOverride,
    hideWeCanText,
  } = props;

  const isExtraSmallScreen = screenClass === 'xs';

  return (
    <div
      style={{
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        paddingBottom: 20,
        marginTop: 10,
      }}
    >
      {showNewCallout
        && (
          <div style={{
            backgroundColor: '#02A34A',
            borderRadius: 10,
            width: 85,
            height: 20,
            textTransform: 'uppercase',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            position: 'absolute',
            textAlign: 'center',
            zIndex: 1,
          }}
          >
            <Typography
              style={{
                color: 'white',
                lineHeight: '22px',
              }}
              text={text('new')}
            />
          </div>
        )
      }
      <div
        style={{
          position: 'relative', // allow buttons to be absolutely positioned
          boxSizing: 'border-box',
          width: '100%',
          paddingTop: 25,
          paddingBottom: isExtraSmallScreen ? 45 : 110, // add space for the buttons on the bottom
          paddingLeft: 25,
          paddingRight: 25,

          borderRadius: 5,
          border: `1px solid ${colors.border}`,
          boxShadow: `0 5px 15px 0 ${ColorUtil.rgbaFromHex(colors.black, 0.05)}, 0 15px 20px 0 ${ColorUtil.rgbaFromHex(colors.shadow, 0.1)}`,

          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <button
          type="button"
          style={{
            border: 'none',
            backgroundColor: 'unset',

            marginBottom: 20,

            display: 'flex',
            justifyContent: 'center',
          }}
          onClick={iconOnClick}
        >
          <img
            src={BundleUtil.getFullyQualifiedURL(iconSrc)}
            alt={title}
            style={{
              userSelect: 'none',
              height: isExtraSmallScreen ? 24 : 48,
            }}
          />
        </button>
        <Typography
          variant="heading1"
          text={title}
          style={{
            textAlign: 'center',
            fontSize: '1.75em',
            marginBottom: 10,
          }}
        />
        <div
          style={{
            marginBottom: 25,
          }}
        >
          <Typography
            variant="caption"
            text={caption}
            style={{
              display: 'inline-block',
              textAlign: 'center',

              marginRight: 5,
            }}
          />
          <Price
            priceHTML={priceHTML}
            style={{
              ...defaultTextStyle,
              fontSize: '1em',
              color: colors.textSecondary,
            }}
          />
        </div>
        <Hidden xs>
          {!hideWeCanText && (
          <Typography
            text={highlightsTextOverride || `${text('we-can')}...`}
            style={{
              textAlign: 'center',
              marginBottom: 10,
            }}
          />
          )
          }
          {hideCheckmarks
            ? (
              highlights.map(highlight => (
                <div style={{ paddingLeft: 30, paddingRight: 30, textAlign: 'center' }}>
                  <Typography
                    text={highlight}
                  />
                </div>
              ))
            )
            : (
              highlights.map(highlight => (
                <ServiceHighlight
                  key={`service-highlight-${highlight.split(' ').join('')}`}
                  text={highlight}
                />
              ))
            )
          }

        </Hidden>
        <div
          style={{
            position: 'absolute',
            bottom: 25,
            textAlign: 'center',
          }}
        >
          {!isExtraSmallScreen
            && (
              <Button
                variant="primary"
                iconName="arrow-r"
                text={buttonTextOverride || text('get-started')}
                onClick={buttonOnClick}
                style={{
                  // add margin to the bottom if there's no link so that buttons line up
                  marginBottom: (!linkText || !linkHref) ? (isExtraSmallScreen ? 0 : 10) : 0,
                }}
              />
            )
          }
          {isExtraSmallScreen
            && (
              <TextLink
                text={buttonTextOverride || text('get-started')}
                href={buttonLinkHref}
              />
            )
          }
          {(linkText && linkHref)
            && (
              <TextLink
                text={linkText}
                href={linkHref}
                containerStyle={{
                  marginTop: 10,
                }}
              />
            )
          }
        </div>
      </div>
    </div>
  );
}

Service.propTypes = {
  iconSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  priceHTML: PropTypes.string.isRequired,
  highlights: PropTypes.arrayOf(PropTypes.string).isRequired,
  iconOnClick: PropTypes.func.isRequired,
  buttonOnClick: PropTypes.func.isRequired,
  buttonLinkHref: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  linkHref: PropTypes.string,
  ...withScreenClassPropTypes,
};

Service.defaultProps = {
  linkText: null,
  linkHref: null,
};

export default withScreenClass(Service);



// WEBPACK FOOTER //
// ./src/components/Service.js